import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { KaayaIcon } from "@/components/KaayaLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    try {
      localStorage.setItem("kaaya_cb", JSON.stringify({ t: new Date().toISOString(), href: window.location.href }));
    } catch (_e) {}
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    const inviteCode = localStorage.getItem("pending_invite_code") || null;
    const hasToken = () => !!localStorage.getItem("kaaya_token");

    if (!sessionId) {
      navigate(hasToken() ? "/chat" : "/", { replace: true });
      return;
    }

    // Guard against the same one-time session_id being exchanged twice (e.g. native WebView
    // reload + any JS handler). If we already handled it, just go to the app.
    if (localStorage.getItem("kaaya_handled_session") === sessionId) {
      navigate("/chat", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", {
          session_id: sessionId,
          invite_code: inviteCode,
        });
        localStorage.setItem("kaaya_handled_session", sessionId);
        try { localStorage.setItem("kaaya_err", "ok"); } catch (_e) {}
        // Persist the session token as a Bearer fallback so auth survives when the cross-site
        // httpOnly cookie is blocked (Safari/iOS ITP, third-party cookies, cross-domain backend).
        if (data.session_token) localStorage.setItem("kaaya_token", data.session_token);
        setUser(data);
        localStorage.removeItem("pending_invite_code");
        // Clean URL fragment
        window.history.replaceState({}, "", "/chat");
        navigate("/chat", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        try { localStorage.setItem("kaaya_err", "FAIL:" + (e?.response?.status || e?.message || String(e))); } catch (_e) {}
        // If a token already exists (the session was exchanged by another handler), stay
        // signed in instead of bouncing to the landing page.
        navigate(hasToken() ? "/chat" : "/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="flex justify-center mb-3"><KaayaIcon size={56} /></div>
        <div className="font-serif-display text-3xl text-foreground mb-1">KAAYA</div>
        <div className="text-muted-foreground">Setting up your health space…</div>
      </div>
    </div>
  );
}
